export default __webpack_public_path__ + "static/media/number.ffd990a9.svg";